import { parseAssignToScheduleActionValue } from "@common/types/transactionRule";
import { useScheduleTemplate } from "@api/scheduleTemplate.api";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: string;
}

export const RuleScheduleAction: React.FC<Props> = ({ value }) => {
    const scheduleTemplateId =
        parseAssignToScheduleActionValue(value)?.scheduleTemplateId ?? null;
    const templateQuery = useScheduleTemplate(scheduleTemplateId);
    const scheduleName = templateQuery.data?.name;

    if (scheduleName == null) {
        return null;
    }

    return (
        <RuleTagRow
            label="Set recognition schedule"
            type="action"
            values={[scheduleName]}
        />
    );
};
